import { CustomGridPageBase } from "../../common/custom-grid-page.base";
import {autoinject, BindingEngine, transient} from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { DataType, SourceType } from "../../../../models/queries/queries.models";

@autoinject()
@transient()
export class SurvivorshipRuleFailures extends CustomGridPageBase {

    constructor(i18N: I18N, protected bindingEngine: BindingEngine) {

        super(i18N, 'Lists', bindingEngine);
        const columns = [];
        columns.push(
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'dataType',
                title: 'Data Type'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'columnName',
                title: 'Column Name'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'errorText',
                title: 'Error Text'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Number,
                isSortable: true,
                name: 'affectedRecordsCount',
                title: 'Affected Records Count'
            });

        columns.forEach((column, index) => {
            column.columnOrder = index;
            column.sortOrder = index;
        });

        this.columns = columns;
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: "odata/SurvivorshipRuleFailures/Genesis.GetSurvivorshipRuleFailures(etlProcessExecutionId =null)",
            columns: this.columns,
            initialFilters: []
        };
    }
}